export var ORDER_BY_OPERATOR_ORDER_BY = 'ORDER BY';
export var ORDER_BY_DIRECTION_ASC = 'ASC';
export var ORDER_BY_DIRECTION_DESC = 'DESC';